/** 应用入口*/
import React from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { RecoilRoot } from 'recoil';
import 'k-soup/dist/index.css';
import './index.css';
import { dismissBootSplash } from './boot/dismissSplash';
import { router } from './routes/index';

console.info('[k_main] 应用启动');

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <RecoilRoot>
      <RouterProvider router={router} />
    </RecoilRoot>
  </React.StrictMode>,
);

// 等浏览器绘出 React 首帧后再淡出 HTML 开机屏，避免白闪
requestAnimationFrame(() => {
  requestAnimationFrame(() => {
    dismissBootSplash();
  });
});
